import { render, staticRenderFns } from "./TangiblesFormBlock.vue?vue&type=template&id=0a0a1849"
import script from "./TangiblesFormBlock.vue?vue&type=script&lang=js"
export * from "./TangiblesFormBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports